import React from 'react'
import styled from '@emotion/styled'
import { IoMdCloseCircleOutline } from 'react-icons/io'

interface ClearableInputProps {
  input: React.ReactNode
  onClear: () => void
  changed: boolean

  width?: string
}

const ClearableInput: React.FC<ClearableInputProps> = ({
  input,
  onClear,
  changed,
  width = '100%',
}) => {
  return (
    <ClearableInputContainer changed={changed} width={width}>
      {input}
      {changed && (
        <button
          type="button"
          onClick={onClear}
          style={{ position: 'absolute', right: 0, top: '-3px' }}
          className="hover:cursor-pointer"
        >
          <IoMdCloseCircleOutline size={22} color="red" />
        </button>
      )}
    </ClearableInputContainer>
  )
}

const ClearableInputContainer = styled.div<{ changed: boolean; width: string }>`
  position: relative;
  width: ${(props) => props.width};
  ${(props) =>
    props.changed
      ? `
  label {
    color: red;
  }
  `
      : ''}
`

export default ClearableInput
